
<!--
  功能： 日期范围选择 带快捷方式
-->
<template>
  <el-date-picker
    v-model="dateValue"
    popper-class="dateRange-box"
    type="daterange"
    align="left"
    :clearable='dateClearable'
    unlink-panels
    range-separator="至"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    @change="changeDateValue"
    :picker-options="pickerOptions">
  </el-date-picker>
</template>
<script>
// 公用
import { handleTime, handleTimeWeek, handleTimeMonth } from '@/components/public'

export default {
  // 组件名称
  name: 'dateRange',
  // 组件参数 接收来自父组件的数据
  props: {
    timeDate: {
      type: Array
    },
    minDisabledData: {
      type: String
    },
    maxDisabledData: {
      type: String
    },
    thisClearable: {
      type: String
    }
  },
  // 组件状态值
  data() {
    const disabledDate = (time) => {
      return time.getTime() < new Date(this.minDisabledData).getTime() || this.maxDisabledData ? time.getTime() > new Date(this.maxDisabledData).getTime() : time.getTime() > new Date().getTime()
    }
    return {
      dateClearable: true,
      pickerOptions: {
        disabledDate(time) {
          return disabledDate(time)
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', [handleTime(new Date(), 0), handleTime(new Date(), 0)])
          }
        }, {
          text: '昨天',
          onClick(picker) {
            picker.$emit('pick', [handleTime(new Date(), 1), handleTime(new Date(), 1)])
          }
        }, {
          text: '过去7天',
          onClick(picker) {
            picker.$emit('pick', [handleTime(new Date(), 7), handleTime(new Date(), 1)])
          }
        }, {
          text: '过去30天',
          onClick(picker) {
            picker.$emit('pick', [handleTime(new Date(), 30), handleTime(new Date(), 1)])
          }
        }, {
          text: '本周',
          onClick(picker) {
            picker.$emit('pick', handleTimeWeek(0))
          }
        }, {
          text: '上周',
          onClick(picker) {
            picker.$emit('pick', handleTimeWeek(1))
          }
        }, {
          text: '本月',
          onClick(picker) {
            picker.$emit('pick', handleTimeMonth(0))
          }
        }, {
          text: '上月',
          onClick(picker) {
            picker.$emit('pick', handleTimeMonth(1))
          }
        }]
        // disabledDate (time) {
        //   let dateTime = new Date()
        //   let endDateTime = dateTime.setDate(dateTime.getDate() - 1)
        //   return (
        //     time.getTime() > new Date(endDateTime).getTime()
        //   )
        // }
      },
      dateValue: ''
    }
  },
  mounted() {
    if (this.timeDate && this.timeDate !== []) {
      this.dateValue = this.timeDate
    }
    if (this.thisClearable === 'false') {
      this.dateClearable = false
    }
  },
  watch: {
  },
  methods: {
    changeDateValue(val) {
      let dateArr = []
      if (val) {
        if (val[0].length === undefined) {
          val.forEach(item => {
            dateArr.push(handleTime(item))
          })
        } else {
          dateArr = val
        }
      }
      this.$emit('dateValue', dateArr)
    }
  }
}
</script>
<style scoped lang='less'>

</style>



// WEBPACK FOOTER //
// src/components/common/dateRange.vue